import * as React from "react";
import { useNavigate } from "react-router";
import HttpLeadRepository from "../../api/request/Lead/Lead.service";
import {
  GetlifeContext,
  UserStatusT,
} from "../../context/GetLifeContext.context";
import { I18nContext } from "../../context/i18n.context";
import { redirect } from "../../Routes/redirect";
import { GetLifeTrackerContext } from "../../context/GetLifeTracker.context";
import { DOMAIN } from "../../constants/Global";
import { tracker } from "../../helpers/Tracking";

export interface ProgressionListI {
  description: string;
  title: string;
  active?: "active";
}

export interface ResponseResetQuote {
  token: string;
  id: string;
  status: UserStatusT;
}

const SQL_DOMAINS = ["sql_es"];

const DecisionPageController = () => {
  const {
    handleCallMe,
    leadId,
    setLeadId,
    setLoading,
    setToken,
    setUserStatus,
    brokerPhone,
    token,
    userStatus,
    gtf_campaign,
    setThemeColor,
    setLogo,
  } = React.useContext(GetlifeContext);

  const { handleTrackerQuestion } = React.useContext(GetLifeTrackerContext);

  const {
    state: { translate },
  } = React.useContext(I18nContext);

  const [data, setData] = React.useState<any>();

  const [progression, setProgression] = React.useState<Array<ProgressionListI>>(
    []
  );

  const isSqlDomain = SQL_DOMAINS.includes(DOMAIN ?? "");

  const navigate = useNavigate();
  const leadRepository = new HttpLeadRepository(leadId, token);

  const fetch = async () => {
    const response = isSqlDomain
      ? await leadRepository.getInfoLeadV2()
      : await leadRepository.getInfoLead();
    const { themeColor, logo } = response;
    if (themeColor) setThemeColor(themeColor);
    if (logo) setLogo(logo);
    setProgression([
      {
        description: translate(
          "decisionPage.Progression.basicInfo.description"
        ),
        title: translate("decisionPage.Progression.basicInfo.title"),
        active: response.basicInfo && "active",
      },
      {
        description: translate(
          "decisionPage.Progression.healthQuestions.description"
        ),
        title: translate("decisionPage.Progression.healthQuestions.title"),
        active: response.healthQuestions && "active",
      },
      {
        description: translate(
          "decisionPage.Progression.paidAndSigned.description"
        ),
        title: translate("decisionPage.Progression.paidAndSigned.title"),
        active: response.paidAndSigned && "active",
      },
      {
        description: translate("decisionPage.Progression.final.description"),
        title: translate("decisionPage.Progression.final.title"),
        active:
          response.basicInfo &&
          response.healthQuestions &&
          response.paidAndSigned &&
          "active",
      },
    ]);
    setData(response);
    setLoading(false);
  };

  const closePage = () => {
    tracker.redirecting("external");
    window.location.replace(`${process.env.REACT_APP_DOMAIN_URL}`);
  };

  const continueProcess = () => {
    setToken(token || "");
    setLeadId(leadId || "");
    if (userStatus === "telesubscription") {
      navigate(`/calculator/4?lead=${leadId}`);
    } else {
      navigate(redirect(userStatus));
    }
  };

  const resetQuote = () => {
    leadRepository.resetQuote().then((response: ResponseResetQuote) => {
      const { token, id, status } = response;
      setToken(token || "");
      setLeadId(id || "");
      setUserStatus(status);
      handleTrackerQuestion({
        type: "tracker",
        data: {
          leadUlid: id,
          campaign: gtf_campaign ?? "reset-quote",
        },
      });

      if (process.env.REACT_APP_DOMAIN_LOCALE === "fr") {
        navigate(`/calculator/9?lead=${id}`);
      } else {
        navigate(`/calculator/4?lead=${id}`);
      }
    });
  };

  React.useEffect(() => {
    (async () => {
      setLoading(true);
      fetch();
    })();
  }, [leadId]);

  return {
    data,
    progression,
    translate,
    handleCallMe,
    closePage,
    continueProcess,
    resetQuote,
    brokerPhone,
    isSqlDomain,
  };
};

export default DecisionPageController;
